﻿import 'bootstrap';

export default class Modal {
    constructor(elem) {
        this.modal = $(elem);
    }

    show(title, body, showCloseIcon, showCloseButton) {
        this.modal.find(".modal-title").html("");
        this.modal.find(".modal-body").html("<div class=\"spinner-border text-primary\" role=\"status\"><span class=\"sr-only\">Loading...</span></div>");
        this.modal.modal({
            keyboard: false,
            backdrop: 'static'
        });

        setFocus();

        if (title != null) {
            this.setTitle(title);
        }

        if (body != null) {
            this.setBody(body);
        }

        if (showCloseIcon) {
            this.modal.find(".closeIcon").show();
        }

        if (showCloseButton) {
            this.appendCloseButton();
        }

        function setFocus() {
            $('.modal').on('shown.bs.modal', function () {
                $(this).find('[autofocus]').focus();

                $(this).addClass("in");
                //$(".modal-backdrop").addClass("in");
            });
        }

        $('.modal').on('hidden.bs.modal', function () {
            $(this).removeClass("in");
            $(".modal-backdrop").remove();
        });
    }

    hide() {
        this.modal.modal("hide");
    }

    setBody(body, showCloseButton) {
        this.modal.find(".modal-body").html(body);
        if (showCloseButton) {
            this.appendCloseButton();
        }
    }

    setTitle(title) {
        this.modal.find(".modal-title").html(title);
    }

    appendCloseButton() {
        var html = "<hr/><div class=\"row\"><div class=\"col-md-12 text-right\"><a href=\"#\" class=\"btn btn-default\" data-dismiss=\"modal\">Sluiten</a></div></div>";
        this.modal.find(".modal-body").append(html);
    }

    toLargeModal() {
        this.modal.find(".modal-dialog").addClass("modal-lg");
    }
}